// extracted by mini-css-extract-plugin
export default {"footer":"GTZdNfKLalWdi2DSRiDt","left":"x4f48xg3YivDsP871cBN","footerDeleteMode":"zfZge9DwT42tZsGEaMvc"};